import React, { Component } from 'react'
import RightDrawer from './RightDrawer'
import { Button, IconButton } from '@material-ui/core'
import classNames from 'classnames';
import { Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import LaunchIcon from '@material-ui/icons/Launch';
type State = {
  drawerSwitch: String,
  rightDrawerOpen: boolean,
  fullScreen: boolean
}

interface Props {
  draggedTag: any,
  classes: any,
  chartType: String,
  userTrades: Set<string>
  isAdmin: boolean,
  onFullScreenChanged?: (isFullscreen: boolean) => void,
  onTradeOpen?: (isTradeOpen: boolean) => void
}

class RightDrawerContainer extends Component<Props,State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      drawerSwitch: 'backlog',
      rightDrawerOpen: false,
      fullScreen: false
    }
  }

  shouldComponentUpdate(nextProps:Props, nextState: State) {
    if(this.state.fullScreen != nextState.fullScreen) {
      return true
    }

    if(this.state.rightDrawerOpen !== nextState.rightDrawerOpen) {
      return true
    }

    if(this.state.drawerSwitch != nextState.drawerSwitch) {
      return true
    }

    return false
  }

  handleDrawerButtonClick = (e, drawerType:string) => {
		const { drawerSwitch } = this.state
		if(!!drawerType && drawerType !== drawerSwitch) {
			this.setState({
				drawerSwitch: drawerType
			})
		}
  }
  
  onRightDrawerClick = () => {
		this.setState({
			rightDrawerOpen: !this.state.rightDrawerOpen,
      fullScreen: false
		})

    if(!!this.props.onTradeOpen) {
      this.props.onTradeOpen(!this.state.rightDrawerOpen)
    }

    if(!!this.props.onFullScreenChanged) {
      this.props.onFullScreenChanged(false)
    }

  }
  
  renderCloseText = () => {
    const { classes } = this.props
    const { rightDrawerOpen } = this.state

    if(rightDrawerOpen) {
      return
    }

    return (
      <div className={classes.DrawerTitleContainer}>
        <Typography className={classes.DrawerTitle}>Backlog / Trade Legend</Typography>
      </div>
    )
  }

  renderRightDrawer = () => {
    const { drawerSwitch, rightDrawerOpen } = this.state; 
    const { classes, draggedTag, chartType, userTrades, isAdmin } = this.props;

    if(!rightDrawerOpen) {
      return
    }

    return (
      <RightDrawer 
          drawerSwitch={drawerSwitch}
          draggedTag={draggedTag}
          classes={classes}
          chartType={chartType}
          userTrades={userTrades}
					isAdmin={isAdmin}
          isFullScreen={this.state.fullScreen}
      />
    )
  }

  onFullScreen = () => {
    this.setState({
      fullScreen: !this.state.fullScreen
    })

    if(!!this.props.onFullScreenChanged) {
      this.props.onFullScreenChanged(!this.state.fullScreen)
    }
  }

  render() {
    const { classes, draggedTag, chartType } = this.props;
    const { drawerSwitch, rightDrawerOpen, fullScreen } = this.state; 

    const rightDrawerFull = !rightDrawerOpen  ? "" : (!fullScreen) ? classes.rightDrawerOpenNormal : classes.rightDrawerOpenFullscreen

    const rightDrawerClass = !!rightDrawerOpen ? classes.rightDrawerOpen : classes.rightDrawerClose
    const drawerList = !!rightDrawerOpen ? classes.DrawerList : classes.DrawerListClosed

    return (
      <div className={classNames(classes.RightDrawer, rightDrawerClass, rightDrawerFull)}>
        <div onClick={this.onRightDrawerClick} className={classes.RightDrawerButton} >
          <IconButton className={classes.DrawerMenuIcon} onClick={this.onRightDrawerClick}>
            <MenuIcon />
          </IconButton>
          {this.renderCloseText()}
        </div>
        <div className={drawerList}>
          <div  className={classes.DrawerListSection}>
            <div className={classes.DrawerButtonContainer}>
            <ToggleButtonGroup onChange={this.handleDrawerButtonClick} value={drawerSwitch} exclusive={true} className={classes.DrawerButtonGroup}>
              <ToggleButton value='backlog'>Backlog</ToggleButton>
              <ToggleButton value='trade'>Trade</ToggleButton>
            </ToggleButtonGroup>
            <IconButton onClick={this.onFullScreen} style={{float: "right"}}><LaunchIcon /></IconButton>

          </div>
          <br/>

            {this.renderRightDrawer()}
          </div>
        </div>
      </div>
    )
  }
}

export default RightDrawerContainer;


// WEBPACK FOOTER //
// ./src/components/Drawers/RightDrawerContainer.tsx